'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _decisivUiUtils = require('decisiv-ui-utils');

var _styledComponentsReactiveGrid = require('styled-components-reactive-grid');

var _modifiers = require('../../utils/modifiers');

var _Row = require('./Row');

var _Row2 = _interopRequireDefault(_Row);

var _Column = require('./Column');

var _Column2 = _interopRequireDefault(_Column);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var StyledInputGroup = (0, _decisivUiUtils.buildStyledComponent)('InputGroup', _styledComponentsReactiveGrid.Container);

function InputGroup(_ref) {
  var modifiers = _ref.modifiers,
      rest = _objectWithoutProperties(_ref, ['modifiers']);

  var inputGroupModifiers = ['padScale_0'].concat(_toConsumableArray((0, _modifiers.modifiersForComponent)(modifiers, StyledInputGroup)));
  return _react2.default.createElement(StyledInputGroup, _extends({ modifiers: inputGroupModifiers }, rest));
}

InputGroup.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

InputGroup.defaultProps = {
  modifiers: []
};

InputGroup.Row = _Row2.default;
InputGroup.Column = _Column2.default;

exports.default = InputGroup;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/InputGroup/index.js
// module id = 1664
// module chunks = 2